import type { ReactNode } from 'react';
import { btns } from '../buttons';

/**
 * Back / Continue / Send (crossmarc/steward-app#1886). `primary` is absent when there is
 * nothing to press (a closed form's last section). `note` sits between the two on a row and
 * above them on a phone, which is where the intake's "not saved yet" explanation lives.
 *
 * Stacked, not reversed, on a phone: reversing would put the forward button above Back
 * visually while Tab and a screen reader still read them the other way round (WCAG 1.3.2).
 */
export function FormFooter({ back, primary, note }: {
  back: { onClick: () => void; disabled?: boolean; describedBy?: string };
  primary?: { label: ReactNode; type?: 'submit' | 'button'; onClick?: () => void; disabled?: boolean; describedBy?: string } | null;
  note?: ReactNode;
}) {
  return (
    <div className="mt-9 flex flex-col gap-3 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between">
      <button type="button" className={`${btns.btn} disabled:cursor-default disabled:opacity-40`} onClick={back.onClick} disabled={back.disabled} aria-describedby={back.describedBy}>
        Back
      </button>
      {note}
      {primary && (
        <button
          type={primary.type ?? 'button'}
          className={`${btns.btnPrim} disabled:cursor-wait disabled:opacity-70`}
          onClick={primary.onClick}
          disabled={primary.disabled}
          aria-describedby={primary.describedBy}
        >
          {primary.label}
        </button>
      )}
    </div>
  );
}
